import type { ComponentProps, ComponentType } from 'react'
import { Loader2 } from 'lucide-react'
import { Button, cn } from '@teach/ui'

interface Props extends ComponentProps<typeof Button> {
  /** Действие этой кнопки идёт — значок сменяется крутилкой, подпись — `busyLabel`. */
  busy: boolean
  icon: ComponentType<{ className?: string }>
  label: string
  busyLabel: string
}

/**
 * Кнопка действия, которая показывает прогресс СРАЗУ на клике: крутилка вместо
 * значка и «…ю…» вместо подписи. Погашенная во время своего же действия, она
 * не бледнеет — иначе нажатая кнопка выглядела бы недоступной, а не работающей.
 */
export const BusyButton = ({ busy, icon: Icon, label, busyLabel, className, ...rest }: Props) => (
  <Button {...rest} aria-busy={busy} className={cn(className, busy && 'disabled:opacity-100')}>
    {busy ? <Loader2 className="animate-spin" /> : <Icon />}
    {busy ? busyLabel : label}
  </Button>
)
